import { useEffect } from "react";

export default function useAutoLogout(onLogout) {
    //const TIEMPO_INACTIVIDAD = 8 * 60 * 60 * 1000; // 8 horas en ms
    //const TIEMPO_INACTIVIDAD = 5000; // 5 segundos
    const TIEMPO_INACTIVIDAD = 30 * 60 * 1000; // 30 minutos en ms



    useEffect(() => {
        const actualizarActividad = () => {
            localStorage.setItem("ultimaActividad", Date.now().toString());
        };

        // Guardar actividad en cada interacción
        window.addEventListener("click", actualizarActividad);
        window.addEventListener("keydown", actualizarActividad);
        window.addEventListener("mousemove", actualizarActividad);
        window.addEventListener("touchstart", actualizarActividad);

        // Revisar en el inicio de la app
        const ultimaActividad = localStorage.getItem("ultimaActividad");
        if (ultimaActividad) {
            const diferencia = Date.now() - parseInt(ultimaActividad, 10);
            if (diferencia > TIEMPO_INACTIVIDAD) {
                onLogout(); // Llamar a tu función de cerrar sesión
            }
        }

        // Intervalo para revisar cada minuto
        const intervalo = setInterval(() => {
            const ultima = localStorage.getItem("ultimaActividad");
            if (ultima) {
                const diferencia = Date.now() - parseInt(ultima, 10);
                if (diferencia > TIEMPO_INACTIVIDAD) {
                    onLogout();
                }
            }
        }, 60000); // 60000 cada minuto   :   1000 cada segundo

        return () => {
            window.removeEventListener("click", actualizarActividad);
            window.removeEventListener("keydown", actualizarActividad);
            window.removeEventListener("mousemove", actualizarActividad);
            window.removeEventListener("touchstart", actualizarActividad);
            clearInterval(intervalo);
        };
    }, [onLogout]);
}
